import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Alert, DatePicker, Form, Input, Modal } from "antd";
// 2. External libraries
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
import styles from "@/styles/Company/Settlements.module.less";
/** Реквизиты внешнего документа счёта (UC1123, P-7). */
const InvoiceExternalDocModal = observer(({ invoice, onClose }) => {
    const { companySettlementsStore: store } = getRootStore();
    const [form] = Form.useForm();
    useEffect(() => {
        if (!invoice)
            return;
        store.clearFormError();
        form.setFieldsValue({
            docNumber: invoice.externalDocNumber ?? "",
            docDate: invoice.externalDocDate ? dayjs(invoice.externalDocDate) : dayjs(),
        });
    }, [invoice]);
    if (!invoice)
        return null;
    const handleCancel = () => {
        store.clearFormError();
        onClose();
    };
    const handleFinish = async (values) => {
        const saved = await store.setExternalDoc(invoice.invoiceId, {
            docNumber: values.docNumber.trim(),
            docDate: values.docDate.format("YYYY-MM-DD"),
        });
        if (saved)
            onClose();
    };
    return (_jsxs(Modal, { open: true, title: `Внешний документ — ${invoice.number}`, onCancel: handleCancel, onOk: form.submit, okText: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", okButtonProps: { loading: store.isSubmitting }, destroyOnHidden: true, children: [store.formError ? (_jsx(Alert, { type: "error", showIcon: true, message: store.formError.text, "data-error-code": store.formError.code ?? undefined, className: styles.notice })) : null, _jsxs(Form, { form: form, layout: "vertical", onFinish: handleFinish, children: [_jsx(Form.Item, { name: "docNumber", label: "\u041D\u043E\u043C\u0435\u0440 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430", rules: [{ required: true, whitespace: true, message: "Укажите номер документа" }], children: _jsx(Input, {}) }), _jsx(Form.Item, { name: "docDate", label: "\u0414\u0430\u0442\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430", rules: [{ required: true, message: "Укажите дату документа" }], children: _jsx(DatePicker, { className: styles.fullWidth, format: "DD.MM.YYYY" }) })] })] }));
});
InvoiceExternalDocModal.displayName = "InvoiceExternalDocModal";
export default InvoiceExternalDocModal;
